/*
 * Cart discount codes via the Ajax Cart API.
 *
 * /cart/update.js accepts { discount: "CODE" } (comma-separated for several) and
 * "" clears them. It answers 200 even for a code the shop will not honour, so
 * success is judged by cart.discount_codes[].applicable, never by status.
 *
 * Handlers are delegated from document because the markup lives inside the
 * cart's .js-contents and is destroyed on every section re-render.
 */
(function () {
  var BUSY = 'is-busy';

  function root(el) {
    return el.closest('[data-miyego-discount]');
  }

  function inDrawer(el) {
    return !!el.closest('cart-drawer, #CartDrawer, .drawer');
  }

  function sectionsFor(el) {
    if (inDrawer(el)) return ['cart-drawer', 'cart-icon-bubble'];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var list = [];
    if (items) list.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    if (footer) list.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
    list.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return list;
  }

  function swap(spec, html) {
    if (!html) return;
    var target = document.getElementById(spec.id);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var source = spec.selector ? doc.querySelector(spec.selector) : doc.getElementById(spec.id);
    var dest = spec.selector ? target.querySelector(spec.selector) : target;
    if (source && dest) dest.innerHTML = source.innerHTML;
  }

  function applyDrawer(html) {
    var el = document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (!el || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('.drawer__inner') || doc.getElementById('CartDrawer');
    var dest = el.querySelector('.drawer__inner') || el;
    if (src && dest) dest.innerHTML = src.innerHTML;
  }

  function showError(box, show) {
    var err = box && box.querySelector('[data-discount-error]');
    if (err) err.hidden = !show;
  }

  async function setDiscount(box, value) {
    var drawer = inDrawer(box);
    var specs = sectionsFor(box);
    var names = drawer ? specs : specs.map(function (s) { return s.section; });

    box.classList.add(BUSY);
    showError(box, false);

    try {
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: value,
          sections: names,
          sections_url: window.location.pathname,
        }),
      });
      var cart = await res.json();

      // A refused code still returns 200 — check the flag, not the status.
      var wanted = (value || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
      var codes = cart.discount_codes || [];
      var rejected = wanted.length > 0 && wanted.some(function (w) {
        return !codes.some(function (c) { return c.code.toUpperCase() === w && c.applicable; });
      });

      if (rejected) {
        box.classList.remove(BUSY);
        showError(box, true);
        return;
      }

      if (drawer) {
        applyDrawer(cart.sections && cart.sections['cart-drawer']);
        swap({ id: 'cart-icon-bubble', selector: '.shopify-section' },
             cart.sections && cart.sections['cart-icon-bubble']);
      } else {
        specs.forEach(function (s) {
          swap(s, cart.sections && cart.sections[s.section]);
        });
      }
      document.dispatchEvent(new CustomEvent('miyego:cart-discount-changed', { detail: cart }));
    } catch (e) {
      box.classList.remove(BUSY);
      showError(box, true);
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    var box = root(form);
    var input = form.querySelector('input[name="discount"]');
    var code = (input && input.value || '').trim();
    if (!code) return;
    setDiscount(box, code);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-discount-remove]');
    if (!btn) return;
    e.preventDefault();
    var box = root(btn);
    var gone = btn.getAttribute('data-discount-remove');
    var keep = [];
    box.querySelectorAll('[data-discount-remove]').forEach(function (b) {
      var c = b.getAttribute('data-discount-remove');
      if (c !== gone) keep.push(c);
    });
    setDiscount(box, keep.join(','));
  });
})();
